import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import MaterialTextFieldComponent from "../textField/MaterialTextFieldCmp";
import SwitchCmp from "../switch/SwitchCmp";
import LoadDocumentCmp from "../thumbnail/loadDocumentCmp";
import ImageEditorCmp from "../dropzone/ImageEditorCmp";
import { toast } from "react-toastify";
import { DocumentUrl } from "../../models/cartable.model";
import { useMutation } from "react-query";
import {
  AddMainCategory,
  AddSubCategory,
  UpdateMainCategory,
  UpdateSubCategory,
} from "../../services/productCategory.service";
import {
  AddMainCategoryRequest,
  AddSubCategoryRequest,
  GetMainCategoryByIdResponse,
  GetSubCategoryByIdResponse,
} from "../../models/productCategory.model"; // Ensure this is the correct path

const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: {
    xs: 350,
    sm: 400,
    md: 600,
  },
  maxWidth: {
    xs: 350,
    sm: 400,
    md: 600,
  },
  maxHeight: "70vh",
  minHeight: "30vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  paddingTop: "4vh",
  borderRadius: "5px",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

interface Props {
  openCategoryModal: boolean;
  setOpenCategoryModal: (open: boolean) => void;
  modalTitle: string;
  textfieldTitle: string;
  serviceName: string;
  categoryById?:
    | GetMainCategoryByIdResponse
    | undefined
    | GetSubCategoryByIdResponse;
  MainCategoryId?: number | undefined;
}
const ModalAddCategory = ({
  openCategoryModal,
  setOpenCategoryModal,
  modalTitle,
  textfieldTitle,
  serviceName,
  categoryById,
  MainCategoryId,
}: Props) => {
  const [status, setstatus] = useState<boolean>(true);
  const [documentLogo, setDocumentLogo] = useState("");
  const [attachmentDocumentLogo, setAttachmentDocumentLogo] = useState<
    DocumentUrl
  >();
  useEffect(() => {
    setDocumentLogo(categoryById?.logo ? categoryById?.logo : "");
  }, [categoryById]);
  const handleFormSubmit = (values: any) => {
    if (MainCategoryId === undefined) {
      const addMainCategory = {} as AddMainCategoryRequest;
      addMainCategory.title = values.Title;
      addMainCategory.englishTitle = values.EnglishTitle;
      addMainCategory.logo = attachmentDocumentLogo || ({} as DocumentUrl);
      addMainCategory.sortIndex = values.SortIndex;
      addMainCategory.hexCode = values.HexCode;
      addMainCategory.isActive = status;
      if (serviceName === "AddMainCategory") {
        AddMainCategoryMutate(addMainCategory);
      } else if (serviceName === "UpdateMainCategory") {
        addMainCategory.id = categoryById?.id;
        UpdateMainCategoryMutate(addMainCategory);
      }
    } else {
      const addSubCategory = {} as AddSubCategoryRequest;
      addSubCategory.mainCategoryId = MainCategoryId!;
      addSubCategory.title = values.Title;
      addSubCategory.englishTitle = values.EnglishTitle;
      addSubCategory.logo = attachmentDocumentLogo || ({} as DocumentUrl);
      addSubCategory.sortIndex = values.SortIndex;
      addSubCategory.hexCode = values.HexCode;
      addSubCategory.isActive = status;
      if (serviceName === "AddSubCategory") {
        AddSubCategoryMutate(addSubCategory);
      } else if (serviceName === "UpdateSubCategory") {
        addSubCategory.id = categoryById?.id;
        UpdateSubCategoryMutate(addSubCategory);
      }
    }
  };

  const { mutateAsync: AddMainCategoryMutate } = useMutation(AddMainCategory, {
    onSuccess: (data: boolean) => {
      if (data === true) {
        toast.success("عملیات با موفقیت انجام شد.");
        setOpenCategoryModal(false);
        setAttachmentDocumentLogo(undefined);
      }
    },
    onError: () => {},
  });
  const { mutateAsync: UpdateMainCategoryMutate } = useMutation(
    UpdateMainCategory,
    {
      onSuccess: (data: boolean) => {
        if (data === true) {
          toast.success("عملیات با موفقیت انجام شد.");
          setOpenCategoryModal(false);
          setAttachmentDocumentLogo(undefined);
        }
      },
      onError: () => {},
    }
  );
  const { mutateAsync: AddSubCategoryMutate } = useMutation(AddSubCategory, {
    onSuccess: (data: boolean) => {
      if (data === true) {
        toast.success("عملیات با موفقیت انجام شد.");
        setOpenCategoryModal(false);
        setAttachmentDocumentLogo(undefined);
      }
    },
    onError: () => {},
  });
  const { mutateAsync: UpdateSubCategoryMutate } = useMutation(
    UpdateSubCategory,
    {
      onSuccess: (data: boolean) => {
        if (data === true) {
          toast.success("عملیات با موفقیت انجام شد.");
          setOpenCategoryModal(false);
          setAttachmentDocumentLogo(undefined);
        }
      },
      onError: () => {},
    }
  );

  const setChildValueLogo = (childValues: any) => {
    setAttachmentDocumentLogo(childValues);
    setDocumentLogo(childValues);
  };
  function handleChoosedImage(image: any, from: string) {
    let maxSize;
    if (maxSize === undefined) {
      maxSize = 1024 * 1000;
    }

    if (image.data.size != null && image.data.size > maxSize) {
      toast.error(" سایز فایل مورد نظر بیشتر از اندازه مجاز است.");
      return;
    }
    let fileUrlObj = {} as DocumentUrl;
    fileUrlObj.fileData = image.data;
    fileUrlObj.fileUrl = image.dataurl;
    fileUrlObj.fileName = image.data.name;
    fileUrlObj.fileType = image.data.type;
    setAttachmentDocumentLogo(fileUrlObj);
  }
  return (
    <>
      <Modal
        open={openCategoryModal}
        onClose={() => {
          setOpenCategoryModal(false);
          setstatus(true);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={deactiveUserStyle}>
          <Grid
            container
            flexDirection={"column"}
            justifyContent={"space-between"}
            alignItems={"center"}
            gap={"2rem"}
          >
            <Grid item>
              <Typography
                component={"p"}
                display={"block"}
                textAlign={"center"}
                color={"#1D4A87"}
                fontSize={"18px"}
                fontWeight={"bold"}
                // marginY={"3rem"}
                // fontSize={"44px"}
              >
                {modalTitle}
              </Typography>
            </Grid>
            <Formik
              initialValues={{
                Title: categoryById?.title ? categoryById?.title : "",
                EnglishTitle: categoryById?.englishTitle
                  ? categoryById?.englishTitle
                  : "",
                documentLogo: categoryById?.logo ? categoryById?.logo : "",
                SortIndex: categoryById?.sortIndex
                  ? categoryById?.sortIndex
                  : "",
                HexCode: categoryById?.hexCode ? categoryById?.hexCode : "",
                IsActive: categoryById?.isActive
                  ? categoryById?.isActive
                  : true,
              }}
              onSubmit={handleFormSubmit}
            >
              {({
                handleSubmit,
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
              }) => (
                <Grid item sx={{ width: "100%" }}>
                  <form onSubmit={handleSubmit}>
                    <Grid
                      container
                      flexDirection={"row"}
                      justifyContent={"start"}
                      spacing={2}
                    >
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Grid container flexDirection={"row"} spacing={2}>
                          <Grid
                            item
                            xs={3}
                            sm={3}
                            md={3}
                            lg={3}
                            style={{ paddingBottom: "5vh" }}
                          >
                            {attachmentDocumentLogo || documentLogo ? (
                              <LoadDocumentCmp
                                className="UploadImageCmpLogo"
                                deleteIcon="true"
                                margin="-1vh"
                                height="13vh"
                                data={attachmentDocumentLogo!}
                                setChildValue={setChildValueLogo}
                                cacheName={undefined}
                                attachments={attachmentDocumentLogo}
                                multiItem={false}
                                picName={"storePic"}
                                document={documentLogo}
                              />
                            ) : (
                              <ImageEditorCmp
                                paddingBottom="0px"
                                minHeight="13vh"
                                height="13vh"
                                handleImageSubmit={(e: any) =>
                                  handleChoosedImage(e, "logo")
                                }
                                fileTitle={"لوگو"}
                                logo="StorefrontIcon"
                              />
                            )}
                          </Grid>
                          <Grid item xs={9} sm={9} md={9} lg={9}>
                            <Grid container flexDirection={"row"} spacing={2}>
                              <Grid item xs={12} sm={12} md={12}>
                                <MaterialTextFieldComponent
                                  placeHolder={textfieldTitle}
                                  label={textfieldTitle}
                                  required={true}
                                  name="Title"
                                  id="Title"
                                  helperText={touched.Title ? errors.Title : ""}
                                  error={touched.Title && Boolean(errors.Title)}
                                  onChange={handleChange}
                                  value={values.Title}
                                  onBlur={handleBlur}
                                />
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                style={{
                                  position: "relative",
                                  bottom: "-1.5vh",
                                }}
                              >
                                <MaterialTextFieldComponent
                                  placeHolder={"عنوان انگلیسی"}
                                  label={"عنوان انگلیسی"}
                                  required={true}
                                  name="EnglishTitle"
                                  id="EnglishTitle"
                                  helperText={
                                    touched.EnglishTitle
                                      ? errors.EnglishTitle
                                      : ""
                                  }
                                  error={
                                    touched.EnglishTitle &&
                                    Boolean(errors.EnglishTitle)
                                  }
                                  onChange={handleChange}
                                  value={values.EnglishTitle}
                                  onBlur={handleBlur}
                                  onKeyDown={(e) => {
                                    if (
                                      /^[آ-ی ء چ]+$/.test(e.key) &&
                                      e.code !== "Space"
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          style={{ paddingTop: "1vh" }}
                        >
                          <Grid container flexDirection={"row"} spacing={2}>
                            <Grid item xs={6} sm={6} md={6} lg={6}>
                              <MaterialTextFieldComponent
                                placeHolder={"کدرنگ"}
                                label={"کدرنگ"}
                                required={true}
                                name="HexCode"
                                id="HexCode"
                                helperText={
                                  touched.HexCode ? errors.HexCode : ""
                                }
                                error={
                                  touched.HexCode && Boolean(errors.HexCode)
                                }
                                onChange={(event: any) => {
                                  const inputValue = event.target.value.replace(
                                    /[^a-fA-F0-9]/g,
                                    ""
                                  );
                                  const value = `#${inputValue}`;
                                  handleChange({
                                    target: {
                                      name: "HexCode",
                                      value: value,
                                    },
                                  });
                                }}
                                value={values.HexCode || "#"}
                                onBlur={handleBlur}
                                onKeyDown={(event) => {
                                  if (
                                    event.code === "Space" ||
                                    (!/^[a-fA-F0-9]$/.test(event.key) &&
                                      event.code !== "Backspace" &&
                                      event.code !== "Delete" &&
                                      event.code !== "ArrowLeft" &&
                                      event.code !== "ArrowRight")
                                  ) {
                                    event.preventDefault();
                                  }
                                }}
                                inputProps={{
                                  maxLength: 7,
                                  style: {
                                    direction: "ltr",
                                    textAlign: "right",
                                  },
                                }}
                              />
                            </Grid>
                            <Grid item xs={6} sm={6} md={6} lg={6}>
                              <MaterialTextFieldComponent
                                // sx={{ maxWidth: "400px" }}
                                placeHolder={"ترتیب نمایش"}
                                label={"ترتیب نمایش"}
                                required={true}
                                name="SortIndex"
                                id="SortIndex"
                                helperText={
                                  touched.SortIndex ? errors.SortIndex : ""
                                }
                                error={
                                  touched.SortIndex && Boolean(errors.SortIndex)
                                }
                                onChange={handleChange}
                                value={values.SortIndex}
                                onBlur={handleBlur}
                                onKeyDown={(event) => {
                                  if (
                                    event.code === "Space" ||
                                    (!/^[0-9]$/.test(event.key) &&
                                      event.code !== "Backspace")
                                  )
                                    event.preventDefault();
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          maxWidth={209}
                          className="certificate-switch"
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            marginTop: "2vh",
                            marginBottom: "2vh",
                          }}
                        >
                          <SwitchCmp
                            Label={"وضعیت"}
                            checked={status === true}
                            onChange={(checked: boolean) => {
                              setstatus(checked);
                            }}
                            onlabel={"فعال"}
                            offlabel={"غیرفعال"}
                            colSize="col-lg-6 col-6"
                          />
                        </Grid>
                        <Grid item width={"100%"}>
                          <Grid
                            container
                            flexDirection={"row"}
                            justifyContent={"center"}
                            spacing={2}
                          >
                            <Grid item xs={12} sm={12} md={12} lg={6}>
                              <Button
                                fullWidth
                                variant="contained"
                                type="submit"
                                disabled={
                                  !values.Title ||
                                  !values.EnglishTitle ||
                                  !values.SortIndex ||
                                  !values.HexCode
                                }
                                className={
                                  !values.Title ||
                                  !values.EnglishTitle ||
                                  !values.SortIndex ||
                                  !values.HexCode
                                    ? "btnForm disabledBtn"
                                    : "btnForm SuccessDefault"
                                }
                              >
                                ثبت
                              </Button>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={6}>
                              <Button
                                fullWidth
                                variant="contained"
                                style={{
                                  fontSize: "1rem",
                                  color: "#fff",
                                  height: "40px",
                                  background: "#607D8B",
                                }}
                                onClick={() => {
                                  setOpenCategoryModal(false);
                                  setAttachmentDocumentLogo(undefined);
                                  setstatus(true);
                                }}
                              >
                                انصراف
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </form>
                </Grid>
              )}
            </Formik>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};

export default ModalAddCategory;
